import { render } from "./DropdownItem.vue?vue&type=template&id=eec67f44&scoped=true"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"

import "./DropdownItem.vue?vue&type=style&index=0&id=eec67f44&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eec67f44"]])

export default __exports__